module.exports = __webpack_public_path__ + "img/没有地址.6f8a6fca.gif";